<template>
    <div>
      <login-personalize-preview-panel-section class="login-personalize-preview-section-logo"
                                               :title="$t('message.loginPersonalize.message.changeLogo')">
        <div class="login-personalize-preview-section-logo-action">
          <input type="file"
                 ref="fileInput"
                 @change="setLogo"
                 hidden />        
  
          <div 
               class="login-personalize-preview-section-logo-action-container">
            <app-button 
                        :label="$t('message.loginPersonalize.message.selectFile')"
                        bordered
                        @click="openFileInput">
            </app-button>            
  
            <app-button v-if="hasTemporaryLogo"
                        :label="$t('message.loginPersonalize.message.removeLogo')"
                        bordered
                        @click="removeLogo">
            </app-button>
          </div>
  
        </div>
      </login-personalize-preview-panel-section>
  
    </div>
  
</template>
  
<script>
import AppButton from "@/components/generic/button/Button";
import LoginPersonalizePreviewPanelSection from "@components/modules/login-personalize/preview/panel/section/LoginPersonalizePreviewPanelSection";

export default {
    components: {
        LoginPersonalizePreviewPanelSection,
        AppButton,
    },

    data() {
        return {
            temporaryLogo: undefined
        };
    },

    props: {
        item: {
            type: Object,
        },   
    },

    computed: {       
        hasTemporaryLogo() {
            return this.temporaryLogo
        }
    },

    methods: {
        openFileInput() {
            this.$refs.fileInput.value = null;
            this.$refs.fileInput.click();
        },
        async setLogo(event) {
            try {
                const fileList = event.target.files;
                const file = fileList[0];
                this.temporaryLogo = file

                const logo = await this.fileToBase64Image(file);
                
                this.$emit("set-temporary-logo", {base64Logo: logo});        
            } catch (error) {
                //
            } 
        },
        fileToBase64Image(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (ev) => {
                    resolve(ev.target.result);
                };

                reader.onerror = () => {
                    reject(reader.error);
                };

                reader.readAsDataURL(file);
            });
        },
        async saveLogo() {             
            await this.$api.core.account.captiveStyle.logo({styleId: this.item.id, file: this.temporaryLogo});
            this.temporaryLogo = undefined;
            this.$emit("saved");        
        },
        removeLogo() {
            this.temporaryLogo = undefined;

            this.$emit("remove-temporary-logo", undefined);
        }
    },

    created() {},

    beforeDestroy() {},
};
</script>
  
<style lang="scss" scoped>
    .login-personalize-preview-section-logo {
        .login-personalize-preview-section-logo-action-container {
            display: flex;
            justify-content: center;
            flex-direction: column;
            gap: 10px;
        }

        .login-personalize-preview-section-background-action-button {
            border: 1px solid #d6d6d6;
            font-size: 14px;
        }
    }
</style>